export enum ConditionName {
  AutomaticSprinkler = "Automatic Sprinkler System",
  SupplementalHeating = "Supplemental heating",
  UnrepairedVisibleDamage = "Unrepaired visible damage",
  BusinessOnPremises = "Business on-premises",
  Trampoline = "Trampoline",
  SwimmingPool = "Swimming Pool",
  SpecialAnimals = "Special Animals",
  LegalTrouble = "Legal Trouble",
  MortgageOrForeClosure = "Past due mortgage payments or foreclosure",
  InsuranceTrouble = "Insurance Trouble",
  NearPublicRoads = "Near public roads",
  TiedDown = "Tied down",
  ThermostatControl = "Thermostat control",
  Utils = "Utilities",
  SecureRailings = "Secure railings",
  IronBars = "Iron bars",
  BurglarAlarm = "Burglar Alarm",
  IbhsFortified = "Storm Mitigation - FORTIFIED",
  WindowsUtilizeGlass = "Storm Mitigation - Impact Resistant Glass",
  WindowsUtilizeShutters = "Storm Mitigation - Storm Shutters",
}
